import CustomSharedLink from '@perpay-web/components/base/CustomSharedLink/CustomSharedLink';
import { getClassName } from '@perpay-web/utils/domUtils';

import styles from './BackButton.scss';

const BackButton = ({ noLink = false, className = '', href = '#', ...rest }) =>
    noLink ? (
        <button
            type='button'
            className={getClassName(styles['link-back'], className)}
            aria-label='Go back'
            {...rest}
        >
            <div className={styles['arrow-back']} aria-hidden='true' />
        </button>
    ) : (
        <CustomSharedLink
            action='link'
            className={getClassName(styles['link-back'], className)}
            href={href}
            aria-label='Go back'
            {...rest}
        >
            <div className={styles['arrow-back']} aria-hidden='true' />
        </CustomSharedLink>
    );

export default BackButton;
